






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { BPopover, BvEvent } from "bootstrap-vue";
import { formatPhone } from "@/utils";

@Component({
  components: {
    BPopover,
  },
  computed: mapGetters("schedule", ["checkedRows"]),
})
export default class ArchivePopover extends Vue {
  @Prop(Boolean) readonly show!: boolean;
  id = "archive-popover";
  checkedRows!: any[];
  //appts: any[] =[];
  loading = false;
  get target() {
    return this.id + "-target";
  }
  archive() {
    this.$modal.show("dialog", {
      title: "Archive Appts",
      text: "Do you want to archive "+ this.checkedRows.length +" appointments, Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/archiveAppt",
                    id
                  );
                  if (result.includes("ERROR SENDING VOICE")) {
                    const error = result.split(":")[1].trim();
                    appt.archiveError = error;
                  } else {
                    appt.archived = true;
                  }
                } catch (error) {
                  appt.archiveError = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  close() {
    if (this.loading) return;
    //this.$root.$emit("bv::hide::popover", this.id);
    //this.$root.$emit("bv::hide::popover");
    this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("ARCHIVE_CLOSE");
  }
  hide(e: BvEvent) {
    if (this.loading) e.preventDefault();
    //this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("ARCHIVE_HIDDEN");
  }
  get formatPhone() {
    return formatPhone;
  }
  mounted() {

  }
}
